<!--  -->
<template>
  <div class="user-main">
    <div id="age2" class="agess"></div>
  </div>
</template>

<script>
export default {
  name: "agemain2",
  data() {
    return {};
  },
  mounted() {
    this.drawLine();
  },
  methods: {
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      let age2 = this.$echarts.init(document.getElementById("age2"));

      var weatherIcons = {
        Sunny: 1 + "data/asset/img/weather/sunny_128.png",
        Cloudy: 2 + "data/asset/img/weather/cloudy_128.png",
        Showers: 3 + "data/asset/img/weather/showers_128.png"
      };

      // 绘制图表
      age2.setOption({
        tooltip: {
          trigger: "item",
          formatter: "{b} : {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          //   top: 'middle',
          bottom: 25,
          left: "center",
          textStyle: { color: "#ffffff", fontSize: 10 },
          data: ["年龄:25<", "25~35", "35~45", "45~55"]
        },
        series: [
          {
            label: {
              normal: {
                position: "inner",
                show: false
              }
            },
            label: {
              //饼图图形上的文本标签
              normal: {
                show: true,
                position: "inner", //标签的位置
                textStyle: {
                  fontWeight: 500,
                  fontSize: 10 //文字的字体大小,
                  //   color:'red'
                },
                formatter: "{d}"
              }
            },
            color: ["#0083D0", "#67EEFF", "#7E9E86", "#E98F6F"],
            type: "pie",
            radius: "80%",
            center: ["50%", "35%"],
            selectedMode: "single",

            labelLine: {
              normal: {
                show: false
              }
            },
            data: [
              { value: 1548, name: "年龄:25<" },
              { value: 510, name: "25~35" },
              { value: 510, name: "35~45" },
              { value: 510, name: "45~55" }
            ]
          }
        ]
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.agess {
  width: 100%;
  height: 100%;
}
</style>
